import script from "./ValidateEmailByCode.vue?vue&type=script&setup=true&lang=js"
export * from "./ValidateEmailByCode.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__